import { useRef } from "react";

import { useTableScrollHandlers } from "app/pages/sales-intelligence/common-components/search-results-table/hooks/useTableScrollHandlers";
import { useVirtualTableScrollY } from "app/pages/sales-intelligence/common-components/search-results-table/hooks/useVirtualTableScrollY";
import { useContactsSorting } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactsSorting";
import { useIsContactsAvailable } from "app/pages/sales-intelligence/sub-modules/contacts-tab/hooks/useIsContactsAvailable";

import ContactsEmptyTable from "app/pages/sales-intelligence/common-components/ContactsEmptyTable/ContactsEmptyTable";
import type { IContactsResultsTableContainerBaseProps } from "../../components/ContactsResultsTable/ContactsResultsTableContainer";
import ContactsResultsTableContainer from "../../components/ContactsResultsTable/ContactsResultsTableContainer";
import {
    StyledContactsEmptyTableContainer,
    StyledTableContentContainer,
} from "../../components/ContactsResultsTable/styles";
import useContactsPagination from "../../hooks/useContactsPagination";
import type { ContactsSearchResults } from "../../types/common";

export interface IContactSearchResultTableContainerProps extends IContactsResultsTableContainerBaseProps {
    searchResults: ContactsSearchResults;
}

const ContactSearchResultTableContainer = ({
    searchResults,
    createColumnsConfigFactory,
    ...tableContainerProps
}: IContactSearchResultTableContainerProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { page, pageSize, handlePageChange } = useContactsPagination();
    const { handleSoringChange } = useContactsSorting();
    const scrollY = useVirtualTableScrollY(containerRef);
    const { onScroll } = useTableScrollHandlers(containerRef);
    const { isContactsDisabledByCountry } = useIsContactsAvailable();

    if (isContactsDisabledByCountry) {
        return (
            <StyledContactsEmptyTableContainer ref={containerRef}>
                <ContactsEmptyTable />
            </StyledContactsEmptyTableContainer>
        );
    }

    return (
        <StyledTableContentContainer ref={containerRef}>
            <ContactsResultsTableContainer
                {...tableContainerProps}
                currentPage={page}
                pageSize={pageSize}
                data={searchResults.rows}
                totalCount={searchResults.totalCount}
                onPageChange={handlePageChange}
                onSortingChange={handleSoringChange}
                createColumnsConfigFactory={createColumnsConfigFactory}
                virtual
                scroll={{ y: scrollY }}
                onScroll={onScroll}
            />
        </StyledTableContentContainer>
    );
};

export default ContactSearchResultTableContainer;
